export { default } from "./src/link";
